import { register } from 'register-service-worker';

export default function registerServiceWorker() {
  register(`${process.env.PUBLIC_URL}/service-worker.js`, {
    updated(registration) {
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: registration }));
    },
  });
}